import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import '@angular/localize/init';
import { IconsModule } from '@epicuro-next/ataraxia/icons';

import { CommercialListRibbonComponent } from './components/commercial-list-ribbon/commercial-list-ribbon.component';

@NgModule({
  imports: [CommonModule, IconsModule],
  declarations: [CommercialListRibbonComponent],
  exports: [CommercialListRibbonComponent],
})
export class CommercialListRibbonModule {}
